import axios from 'axios'
import {getDate, getDateWithBufor} from '../helpers/date.js'

export default {

    state: {
        dealers:[],
        brands: [
            {
                val:'BMW',
                name:'BMW'
            },
            {
                val:'BMW Motorrad',
                name:'BMW Motorrad'
            },
            {
                val:'BMWi',
                name:'BMWi'
            },
            {
                val:'MINI',
                name:'MINI'
            }
        ],
        services: [
            { 
                val:1,
                name: 'Olej silnikowy',
                text: 'Wymiana oleju silnikowego',
                icon: require('../assets/olej-silnikowy.jpg')
            },
            { 
                val:2,
                name: 'Płyn hamulcowy',
                text: 'Wymiana płynu hamulcowego',
                icon: require('../assets/plyn-hamulcowy.jpg')
            },
            { 
                val:3,
                name: 'Hamulce przednie',
                text: 'Serwis hamulców przednich / wymiana klocków',
                icon: require('../assets/hamulce-przednie.jpg')
            },
            { 
                val:4,
                name: 'Hamulce tylne',
                text: 'Serwis hamulców tylnych / wymiana klocków',
                icon: require('../assets/hamulce-tylne.jpg')
            },
            { 
                val:5,
                name: 'Wkład filtra powietrza',
                text: 'Serwis wkładu filtra powietrza',
                icon: require('../assets/wklad-filtra-powietrza.jpg')
            },
            { 
                val:6,
                name: 'Mikrofiltr',
                text: 'Przegląd / wymiana mikrofiltra(ów)',
                icon: require('../assets/mikro-filtr.jpg')
            },
            { 
                val:7,
                name: 'Filtr paliwa',
                text: 'Serwis filtru paliwa',
                icon: require('../assets/filtr-paliwa.jpg')
            },
            { 
                val:8,
                name: 'Filtr obiegu powietrza',
                text: 'Przegląd / wymiana mikrofiltra(ów) obiegu powietrza',
                icon: require('../assets/filtr-obiegu-powietrza.jpg')
            },
            { 
                val:9,
                name: 'Wymiana świec',
                text: 'Wymiana świec zapłonowych',
                icon: require('../assets/wymiana-siwec.jpg')
            },
            { 
                val:10,
                name: 'Wymiana kół / opon',
                text: 'Wymiana kół / opon',
                icon: require('../assets/wymiana-kol.jpg')
            }
        ],
        timeOfday:[
            {
                val:1,
                name:'O każdej porze',
                term:{
                    hour_from:null,
                    hour_to:null
                }
            },
            {
                val:2,
                name:'Przed południem',
                term:{
                    hour_from:null,
                    hour_to:12
                }
            },
            {
                val:3,
                name:'Po południu',
                term:{
                    hour_from:12,
                    hour_to:null
                }
            }
        ],
        localizationsOpenHours:[
            { // Poznań
                id:1,
                hour_to:"18:31"
            },
            { // Warszawa
                id:2,
                hour_to:"16:31"
            },
            { // Wrocek
                id:3,
                hour_to:"18:31"
            }
        ],
        additionalOptions:[
            {
                val:'Chcę czekać na ukończenie naprawy pojazdu',
                name:'Chcę czekać na ukończenie naprawy pojazdu'
            },
            {
                val:'Potrzebuję mobilności',
                name:'Potrzebuję mobilności'
            },
            {
                val:'Chcę telefon zwrotny od serwisu',
                name:'Chcę telefon zwrotny od serwisu'
            }
        ],
        replacementCars:[
            {
                val:'1',
                name:'Samochód zastępczy BMW',
                text:'Płatny zamochód zastępczy BMW - 123zł/dobę netto'
            }
        ],
        admissionTerms: [],
        repairTerms:[],
        avaibleTerms:[],
        termComparedTimeBufor:29, // margines czasu dla doradcy (połowa godziny 30min)
        serviceTermMoving:{
            10:() => { //wymiana opon i kół

                let date = new Date();
                switch (date.getDay()) {
                    case 5: // piątek + 3 dni
                            date.setDate(date.getDate()+3);
                        break;
                    case 6: // sobota + 2 dni
                            date.setDate(date.getDate()+2);
                        break;
                    default:
                            // date.setDate(date.getDate()-1);
                            date.setTime(date.getTime() + (48*60*60*1000));
                        break;
                }

                return date;

            }, 
            default:() => {

                let date = new Date();
                switch (date.getDay()) {
                    case 5: // piąteczek, piątunio + 3 dni
                            date.setDate(date.getDate()+2);
                        break;
                    case 6: // sobota + 2 dni
                            date.setDate(date.getDate()+1);
                        break;
                    default:
                            // date.setDate(date.getDate()-1);
                            date.setTime(date.getTime() + (16*60*60*1000));
                        break;
                }
                return date;

            }

        },
        detepickerConfig:{
            formatLocale: {
                // MMMM
                months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
                // MMM
                monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
                // dddd
                weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
                // ddd
                weekdaysShort: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                // dd
                weekdaysMin: ['Nd', 'Po', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
                // first day of week
                firstDayOfWeek: 1
            },
            range(date){
                return this.$store.getters['definitions/getFirstPossibleDate'] > date || typeof this.$store.getters['definitions/getDetepickerDates'](date) == 'string'
            },
            disabledDays:[
                '01-01', // Nowy Rok
                '01-06', // Święto Trzech Króli
                '04-04', // Wielkanoc
                '04-05', // Poniedziałek Wielkanocny
                '05-01', // Święto Pracy
                '05-03', // Święto Konstytucji 3 Maja
                '05-23', // Zielone Świątki
                '06-03', // Boże Ciało
                '08-15', // Święto Wniebowzięcie Najświętszej Maryi Panny
                '11-01', // Wszystkich Świętych
                '11-11', // Święto Niepodległości
                '12-25', // Boże Narodzenie
                '12-26' // Boże Narodzenie
            ]
        },
        brand_id:13,
        models:[]
    },
    mutations:{
        setDealers(state,payload) {
            state.dealers = payload;
        },
        setAddmissionTerms(state,payload){
            state.admissionTerms = payload;
        },
        setRepairTerms(state,payload){
            state.repairTerms = payload;
        },
        setReplacementCars(state,payload){
            state.replacementCars = payload;
        },
        setAvaibleTerms(state,payload){
            state.avaibleTerms = payload;
        },
        setBrands(state,payload){
            state.brands = payload
        },
        setModels(state,payload){
            state.models = payload
        }
    },
    getters:{
        getDealers: state => state.dealers,
        getBrands: state => state.brands,
        getServices: state => state.services,
        getTimeOfDay: state => state.timeOfday,
        getTimeOfDayWithDealersHours: (state, getters, rootState, rootGetters) => {
            
            if(!rootGetters['lead/getLead'].dealer_id){
                return state.timeOfday
            }

            let hourTo = state.localizationsOpenHours.find(e => e.id == rootGetters['lead/getLead'].dealer_id);

            return state.timeOfday.map(e => {
                return {
                    ...e,
                    term:{
                        ...e.term,
                        hour_to: e.term.hour_to == null? hourTo.hour_to:e.term.hour_to
                    }
                }
            })

        },
        getAdditionalOptions: state => state.additionalOptions,
        getReplacementCars: state => state.replacementCars,
        getAddmissionTerms: state => state.admissionTerms,
        getRepairTerms: state => state.repairTerms,
        getAvaibleTerms: state => state.avaibleTerms,
        getDetepickerConfig: state => state.detepickerConfig,
        getServiceTermMoving: state => state.serviceTermMoving,
        getLocalizationsOpenHours: state => state.localizationsOpenHours,
        getFirstPossibleDate: (state, getters, rootState, rootGetters) => {
            // sprawdzam i pobieram index reguły dla ostatniej wybranej usługi
            let serviceMovingIndex = Object.keys(state.serviceTermMoving).indexOf(String(rootGetters['lead/getLead'].services_val.slice(-1).pop()))
            // jak znalazło regułę to ją odpalam
            if(serviceMovingIndex >= 0){
                var startDate = state.serviceTermMoving[Object.keys(state.serviceTermMoving)[serviceMovingIndex]]();
            }else{ // jak nie to default
                var startDate =  state.serviceTermMoving.default();
            }
            return startDate;
        },
        getDetepickerDates: (state) => (date) => { // zwraca datę jeżeli święto
            return new Date() > date || state.detepickerConfig.disabledDays.map( e => new Date(date.getFullYear()+"-"+e).toUTCString()).find(d => {
                return d == new Date(Date.UTC(date.getFullYear(),date.getMonth(), date.getDate())).toUTCString()
            })
        },
        getBrands: state => state.brands,
        getModels: state => state.models
    },
    actions:{
        async fetchDealers({commit,state, rootState}) {
            const {data} = await axios.get('/dealers?service=1&brand_id='+rootState.lead.lead.brand_val);
            commit('setDealers',data.dealers);
        },
        // async fetchBrands({commit,state}) {
        //     const {data} = await axios.get('/car-brands-all');
        //     commit('setBrands',data.brands);
        // },
        async fetchModels({commit,state}) {
            const {data} = await axios.get('/car-models-all',{
                params:{
                    brand_id: state.brand_id,
                    limit:10000
                }
            });
            commit('setModels',data.models);
        },  
        async fetchServiceAdmissionTerms({commit,state},params) {
            const {data} = await axios.get('/service-admission-terms',{
                params:{
                    ...params,
                    mechanic:1,
                    mechanic_offset_min:state.termComparedTimeBufor,
                    days:7
                }
            });
            // commit('setAddmissionTerms',data.terms);
            commit('setAvaibleTerms',data.terms);
        },
        // async fetchServiceRepairTerms({commit,state},params) {
        //     const {data} = await axios.get('/service-repair-terms',{
        //         params:{
        //             ...params,
        //             mechanic:1,
        //             mechanic_offset_min:state.termComparedTimeBufor,
        //             days:7
        //         }
        //     });
        //     commit('setRepairTerms',data.terms);
        // },
        // filterAvaibleTerms({commit,state}) {

        //     let tempAvaibleTerms = [];

        //     Object.keys(state.admissionTerms).forEach( a => {
       
        //         // termin doradcy z buforem
        //         let admissionTermDate = getDateWithBufor(getDate(state.admissionTerms[a]),state.termComparedTimeBufor);

        //         let metchedRepairTerm = state.repairTerms.find( r => {
        //             // termin mechanika
        //             let repairTermDate = getDate(r);
        //             return admissionTermDate.getTime() < repairTermDate.getTime()?true:false;

        //         });

        //         if(metchedRepairTerm){
        //             tempAvaibleTerms = [
        //                 ...tempAvaibleTerms,
        //                 {
        //                     ...state.admissionTerms[a],
        //                     repair:metchedRepairTerm
        //                 }
        //             ];
        //         }

        //     });

        //     commit('setAvaibleTerms',tempAvaibleTerms);

        // },
        async fetchServiceCars({commit, state, rootState },params) {
            const {data} = await axios.get('/service-cars',{
                params: {
                    dealer_id:rootState.lead.lead.dealer_id,
                    date:rootState.lead.lead.date,
                    hour:rootState.lead.lead.hour_from,
                    hour_to:rootState.lead.lead.hour_to,
                }
            });
            commit('setReplacementCars',data.cars);
        }
    },
    namespaced:true
}